import { MediaQueryContext } from 'libs/contexts';
import { useMemo } from 'react';

export default function MediaQueryProvider({
  children,
  isMobile,
}: {
  children: React.ReactNode;
  isMobile: boolean;
}) {
  const phoneBreakpoint = isMobile ? 'screen and (min-width: 1px)' : 'screen and (max-width: 1px)';
  const desktopBreakpoint = isMobile
    ? 'screen and (max-width: 1px)'
    : 'screen and (min-width: 1px)';
  const value = useMemo(
    () => ({
      isMobile,
      phoneBreakpoint,
      desktopBreakpoint,
    }),
    [desktopBreakpoint, isMobile, phoneBreakpoint],
  );

  return <MediaQueryContext.Provider value={value}>{children}</MediaQueryContext.Provider>;
}
